<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="广告链接" prop="advertisementUrl" >
        <a-upload
          listType="picture-card"
          class="avatar-uploader video-uploader"
          v-model="form.advertisementUrl"
          :showUploadList="false"
          :beforeUpload="beforeUpload"
          :customRequest="handleChange"
        >
            <div v-if="form.advertisementUrl" class="upload-video-wrapper">
              <video
                :src="form.advertisementUrl"
                controls
                style="width: 100%; height: 100%; object-fit: contain;"
                @click.stop
              >
                您的浏览器不支持 video 标签。
              </video>
              <div v-if="uploadLoading" class="upload-mask">
                <a-icon type="loading" style="font-size: 24px; color: #1890ff;"/>
              </div>
              <div v-if="!uploadLoading" class="video-replace-overlay" @click.stop="triggerFileSelect">
                <div class="video-replace-hint">
                  <a-icon type="edit" style="font-size: 16px; color: #fff;"/>
                  <span style="margin-left: 4px; color: #fff; font-size: 12px;">点击更换</span>
                </div>
              </div>
            </div>
          <div v-else>
            <a-icon :type="uploadLoading ? 'loading' : 'plus'"/>
            <div class="ant-upload-text">上传视频</div>
          </div>
        </a-upload>
      </a-form-model-item>


      <a-form-model-item label="备注" prop="remark" >
        <a-input  v-model="form.remark" placeholder="请输入备注" />
      </a-form-model-item>

      <a-form-model-item label="解锁秒数" prop="unlockSeconds" >
        <a-input-number :min="0" :precision="0" v-model="form.unlockSeconds" placeholder="请输入解锁秒数" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getAdvertisement, addAdvertisement, updateAdvertisement } from '@/api/video/advertisement'
import UploadFileToVOD from "@/api/vod.js"

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      uploadLoading: false,
      // 表单参数
      form: {
        id: null,

        advertisementUrl: null,

        isOpen: null,

        unlockSeconds: null,

        remark: null,

        createTime: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        advertisementUrl: [
          { required: true, message: '请上传广告视频', trigger: 'change' }
        ],
        remark: [
          { required: true, message: '请输入备注', trigger: 'blur' }
        ],
        unlockSeconds: [
          { required: true, message: '请输入解锁秒数', trigger: 'blur' },
          { type: 'number', message: '解锁秒数必须为数字', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        advertisementUrl: null,
        isOpen: null,
        unlockSeconds: null,
        remark: null,
        createTime: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getAdvertisement({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateAdvertisement(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addAdvertisement(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /** 视频上传处理 */
    handleChange(info) {
      const that = this
      that.uploadLoading = true
      new UploadFileToVOD([info.file], {
        success: function (fileName) {
          that.form.advertisementUrl = fileName[0] // 视频URL
          that.uploadLoading = false
          that.$message.success('视频上传成功')
        },
        error: function (err) {
          that.uploadLoading = false
          const errorMsg = err && err.message ? err.message : '上传失败，请重试'
          that.$message.error(errorMsg)
        }
      })
    },
    /** 上传前验证 */
    beforeUpload: function (file) {
      const fileType = file.type
      // 验证是否为视频文件
      if (fileType.indexOf('video') < 0) {
        this.$message.warning('请上传视频文件')
        this.uploadLoading = false
        return false
      }
      // 验证文件大小（例如：最大500MB）
      const isLt500M = file.size / 1024 / 1024 < 500
      if (!isLt500M) {
        this.$message.warning('视频文件大小不能超过 500MB')
        this.uploadLoading = false
        return false
      }
      this.form.advertisementUrl = ''
      this.uploadLoading = true
      return true
    },
    /** 触发文件选择 */
    triggerFileSelect() {
      // 创建一个隐藏的 input 元素来触发文件选择
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = 'video/*'
      input.style.display = 'none'
      const that = this
      input.onchange = function(e) {
        const file = e.target.files[0]
        if (file) {
          // 先验证文件
          const isValid = that.beforeUpload(file)
          if (isValid !== false) {
            // 验证通过，开始上传
            that.handleChange({ file })
          }
        }
        // 清理 input
        if (document.body.contains(input)) {
          document.body.removeChild(input)
        }
      }
      document.body.appendChild(input)
      input.click()
    },
  }
}
</script>

<style lang="less" scoped>
.upload-video-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.video-replace-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  background: transparent;
  border-radius: 4px;
}

.upload-video-wrapper:hover .video-replace-overlay {
  opacity: 1;
  background: rgba(0, 0, 0, 0.3);
}

.video-replace-hint {
  background: rgba(0, 0, 0, 0.7);
  padding: 8px 12px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  pointer-events: none;
}

.upload-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
  border-radius: 4px;
}

.video-uploader {
  :deep(.ant-upload-select-picture-card) {
    width: 300px;
    height: 200px;
  }

  :deep(.ant-upload-select-picture-card:hover) {
    border-color: #1890ff;
  }
}
</style>
